import { ArchiveIcon } from "components/icons/ArchiveIcon";
import React from "react";

export const ActionItemArchivedMessage = () => {
  return (
    <div className="t-px-2 t-py-1 t-rounded t-w-auto t-bg-blue-0 t-border t-border-solid t-text-blue-80 t-border-blue-10 t-flex t-gap-1 t-items-center t-text-body-sm">
      <ArchiveIcon />
      Item has been archived by Inkle
    </div>
  );
};
